/*
 * Copyright (c) 2026. Bolmate B.V.
 */

import {PeriodLabel} from './enums.ts';
import IDate from '@dvrd/idate';
import {PeriodRangeFunc} from './types.ts';

const startOfPrevious = (unit: 'week' | 'month' | 'quarter' | 'year'): IDate =>
    IDate.now().startOf(unit).subtract(1, unit);

const endOfPrevious = (unit: 'week' | 'month' | 'quarter' | 'year'): IDate =>
    IDate.now().startOf(unit).subtract(1, 'millisecond');

export const PRESET_PERIODS: Record<Exclude<PeriodLabel, PeriodLabel.CUSTOM>, PeriodRangeFunc> = {
    [PeriodLabel.TODAY]: () => [IDate.now().startOf('day'), IDate.now().endOf('day')],
    [PeriodLabel.YESTERDAY]: () => [
        IDate.now().subtract(1, 'day').startOf('day'),
        IDate.now().subtract(1, 'day').endOf('day')
    ],
    [PeriodLabel.LAST_7_DAYS]: () => [IDate.now().subtract(7, 'days').startOf('day'), IDate.now().endOf('day')],
    [PeriodLabel.LAST_30_DAYS]: () => [IDate.now().subtract(30, 'days').startOf('day'), IDate.now().endOf('day')],
    [PeriodLabel.LAST_90_DAYS]: () => [IDate.now().subtract(90, 'days').startOf('day'), IDate.now().endOf('day')],
    [PeriodLabel.WEEK_TO_DATE]: () => [IDate.now().startOf('week'), IDate.now().endOf('day')],
    [PeriodLabel.MONTH_TO_DATE]: () => [IDate.now().startOf('month'), IDate.now().endOf('day')],
    [PeriodLabel.QUARTER_TO_DATE]: () => [IDate.now().startOf('quarter'), IDate.now().endOf('day')],
    [PeriodLabel.YEAR_TO_DATE]: () => [IDate.now().startOf('year'), IDate.now().endOf('day')],
    [PeriodLabel.LAST_WEEK]: () => [startOfPrevious('week'), endOfPrevious('week')],
    [PeriodLabel.LAST_MONTH]: () => [startOfPrevious('month'), endOfPrevious('month')],
    [PeriodLabel.LAST_QUARTER]: () => [startOfPrevious('quarter'), endOfPrevious('quarter')],
    [PeriodLabel.LAST_YEAR]: () => [startOfPrevious('year'), endOfPrevious('year')],
    [PeriodLabel.ALL]: () => [null, null]
};
